import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";
import { SOLUTIONS, BRAND_LOGO_STACKED, CALENDLY_URL } from "../lib/site";

export default function Footer() {
  return (
    <footer className="bg-[#0A192F] text-[#FDFBF7] py-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img
            src={BRAND_LOGO_STACKED}
            alt="Aligned Education Systems"
            className="h-40 w-auto"
          />
          <p className="mt-6 text-[#FDFBF7]/70 max-w-md leading-relaxed">
            AlignED is a Leadership Operating System&trade; for K&ndash;12. Powered by the AlignED Method&trade;, it helps school and district leaders create Consistent Execution&trade; across attendance, behavior, and enrollment.
          </p>
          <p className="mt-4 text-sm italic text-[#FDFBF7]/55 max-w-md leading-relaxed">
            Better leadership builds better systems. Better systems create better student experiences.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-widest text-[#FDFBF7]/60">Leadership Systems</div>
          <ul className="mt-4 space-y-3">
            {SOLUTIONS.map((s) => (
              <li key={s.slug}>
                <Link to={s.path} className="text-[#FDFBF7]/90 hover:text-[#D4AF37] transition-colors" data-testid={`footer-link-${s.slug}`}>
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-widest text-[#FDFBF7]/60">Explore</div>
          <ul className="mt-4 space-y-3">
            <li><Link to="/about" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-about-link">About</Link></li>
            <li><Link to="/district-systems-overview" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-districts-link">For Districts</Link></li>
            <li><Link to="/insights" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-insights-link">Insights</Link></li>
            <li><Link to="/alignment-check" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-alignment-check-link">Alignment Check&trade;</Link></li>
            <li><Link to="/faq" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-faq-link">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-contact-link">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-widest text-[#FDFBF7]/60">Start the conversation</div>
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noreferrer"
            className="mt-4 inline-flex items-center gap-2 border border-[#FDFBF7]/40 px-5 py-2.5 text-sm hover:bg-[#FDFBF7] hover:text-[#0A192F] transition-colors"
            data-testid="footer-walkthrough-btn"
          >
            <Calendar className="w-4 h-4" strokeWidth={1.5} /> Schedule a Walkthrough
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-16 pt-8 border-t border-[#FDFBF7]/10 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
        <div className="text-sm text-[#FDFBF7]/60">
          © {new Date().getFullYear()} Aligned Education Systems. All rights reserved.
        </div>
        <div className="text-sm text-[#FDFBF7]/60">Built for K&ndash;12 school and district leaders.</div>
      </div>
    </footer>
  );
}
